import { render } from "./ConsistencyCheckSection.vue?vue&type=template&id=54440f14&scoped=true"
import script from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"
export * from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"

import "./ConsistencyCheckSection.vue?vue&type=style&index=0&id=54440f14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54440f14"]])

export default __exports__